import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import {TwoOptionsPanel} from "@/scenes.ui/two-options-panel";
import {InfoPanel} from "@/scenes.ui/info-panel";


export class RateAppPanel extends TwoOptionsPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, rateText: string, onAcceptCallback: () => void) {
        let infoPanel = new InfoPanel(scene, canvas, Tr('opr'), Tr('ty.for.op'),
            Tr('we.do.best'), () => {
            }, Tr('horosho'));
        let ratePanel = new TwoOptionsPanel(scene, canvas, Tr('opr'),
            Tr('m.ty.op'), Keys.ATLAS_EDU, 'edu-female-cat', rateText,
            Tr('hlp.evlv'), onAcceptCallback, Tr('rate'), 2, 15, 40);
        super(scene, canvas, Tr('opr'),
            Tr('dr.pl'), Keys.ATLAS_EDU, 'edu-female-cat', Tr('shr.opin'),
            Tr('d.u.like'), () => {
                ratePanel.openAnimated();
            }, Tr('like'), 5, 15, 40, Tr('n.like'), () => {
                infoPanel.openAnimated();
            });
    }
}